module.exports = __webpack_public_path__ + "static/img/cor-wlw.1cc132a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cor-wlw.png
// module id = H4cW
// module chunks = 0